import styled, { keyframes } from 'styled-components';

const move = keyframes`
  from {
    offset-distance: 100%;
  }
  to {
    offset-distance: 0;
  }
`;

type VehicleProps = {
  path: string;
};

export const Vehicle = styled.image<VehicleProps>`
  display: none;

  // Only show the vehicle if we can animate it
  @supports ((offset-path: path('')) and (offset-distance: 0)) {
    display: initial;
    offset-path: path('${props => props.path}');
    animation: ${move} 8s linear infinite;
  }
`;
